import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

const useDeleteCategory = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteCat,
        isPending: isDelete,
    } = useMutation({
        mutationFn: deleteCategory,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete category");
        },
    });

    return {
        deleteCat,
        isDelete,
    };
};

export default useDeleteCategory;
